import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Layout from "./layout";
import Herosection, { SocialBanner } from "../components/Landing/Herosection";
import PlatformStats from "../components/Landing/PlatformStats";
import ValueProps from "../components/Landing/ValueProps";
import HowItWorks from "../components/Landing/HowItWorks";
import EarnAffiliate from "../components/Landing/EarnAffiliate";
import ShoppingNow from "../components/Landing/ShoppingNow";
import Review from "../components/Landing/Review";
import Faq from "../components/Landing/Faq";
import Cta from "../components/Landing/Cta";
import "../styles/_homepage.scss";

/**
 * Landing funnel:
 * Hero → social banner → trust → pillars → how it works → earn → live shopping → reviews → FAQ → CTA
 */
const Landing = () => {
  useEffect(() => {
    document.body.classList.remove("no-scroll");
  }, []);

  return (
    <Layout>
      <motion.div
        id="main-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.55 }}
      >
        <Herosection />
        <SocialBanner />
        <PlatformStats />
        <ValueProps />
        <HowItWorks />
        <EarnAffiliate />
        <ShoppingNow />
        <Review />
        <Faq />
        <Cta />
      </motion.div>
    </Layout>
  );
};

export default Landing;
